"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const abis_1 = require("../../abis");
const erc20_contract_interface_1 = require("./erc20-contract-interface");
class WrappedToken extends erc20_contract_interface_1.ERC20 {
    constructor(connectionConfig, contractAddress, unit) {
        super(connectionConfig, contractAddress, unit);
        this.contract = new this.web3Eth.Contract(abis_1.WrappedTokenABI, contractAddress);
    }
    deposit(amountWei) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = (0, bignumber_js_1.default)(amountWei).toFixed(0);
            return this.contractSendMethod("deposit", value);
        });
    }
    withdraw(amountWei) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethod("withdraw", "0", [amountWei]);
        });
    }
}
exports.default = WrappedToken;
//# sourceMappingURL=wrapped-token-contract-interface.js.map